var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var EventFul = /** @class */ (function () {
    function EventFul() {
        this._eventListeners = {};
    }
    EventFul.prototype.on = function (eventName, listener) {
        var listenerList = this._eventListeners[eventName] || [];
        var exsitListener = listenerList.length > 0 && listenerList.some(function (item) { return item === listener; });
        if (!exsitListener && typeof listener === 'function') {
            listenerList.push(listener);
            this._eventListeners[eventName] = listenerList;
        }
    };
    EventFul.prototype.off = function (eventName, listener) {
        var listenerList = this._eventListeners[eventName] || [];
        if (typeof listener === 'undefined') {
            delete this._eventListeners[eventName];
        }
        else if (typeof listener === 'function') {
            var exsitIndex = listenerList.indexOf(listener);
            if (exsitIndex !== -1) {
                listenerList.splice(exsitIndex, 1);
            }
            this._eventListeners[eventName] = listenerList;
        }
    };
    EventFul.prototype.dispatch = function (type) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var listenerList = this._eventListeners[type] || [];
        listenerList.forEach(function (listener) { return listener.apply(null, args); });
        this.onEvent.apply(this, __spreadArrays([type], args));
    };
    EventFul.prototype.removeAllListeners = function () {
        this._eventListeners = {};
    };
    // eslint-disable-next-line no-unused-vars
    EventFul.prototype.onEvent = function (type) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        // nothing
    };
    return EventFul;
}());
export default EventFul;
